module.exports = __webpack_public_path__ + "img/D201801_3.3486fe33.jpg";